module.exports = __webpack_public_path__ + "static/img/kp.d56a16b5.png";